import React from 'react';

import { entityComponents } from '../../constants/entityComponents';
import { makeUrlForLodgeCard } from './utils';

const Cards = props => {
  const {
    cardData,
    theme,
    slideIndex,
    openSlider,
    edit,
    modalType,
    setServiceModalConfig,
    patchInfo,
    placeName,
    dayDate,
  } = props;

  const Entity = entityComponents[theme];
  let url = '';

  const handleClick = () => {
    if (modalType === 'dayModal') setServiceModalConfig({ patchInfo, modalType });
    if (theme === 'flights') return null;

    openSlider({ slideIndex, themeType: theme });
  };

  if (theme === 'lodges' || theme === 'lodgings') {
    if (modalType === 'dayModal') {
      url = makeUrlForLodgeCard({
        dayDate,
        cardData,
        patchInfo,
        placeName,
        isAdded: true,
      });
    } else if (modalType === 'trekDayEdit') {
      url = makeUrlForLodgeCard({
        dayDate,
        cardData,
        patchInfo,
        placeName,
        isAdded: edit.isAdded,
      });
    } else {
      url = makeUrlForLodgeCard({ dayDate, cardData, patchInfo, placeName });
    }
  }

  return (
    <Entity cardData={cardData} handleCardClick={handleClick} editable={edit} url={url} />
  );
};

export default Cards;



// WEBPACK FOOTER //
// ./src/screens/Trek/Cards.js